import SectionMessage from 'components/SectionMessage';

const ViewSectionMessage = ({ message }: { message: any }) => {
  return (
    <div className="d-flex align-items-center justify-content-center mt-5">
      <SectionMessage message={message} />
    </div>
  );
};

export default ViewSectionMessage;
